// extracted by mini-css-extract-plugin
export var header = "header-module--header--knWBH";
export var title = "header-module--title--aK00B";
export var navLinks = "header-module--nav-links--UaIZt";
export var siteNavList = "header-module--site-nav-list--qzZhA";
export var siteNavItem = "header-module--site-nav-item--nFKwO";
export var active = "header-module--active--XpLlV";
export var externalLinkList = "header-module--external-link-list--hx99p";
export var externalLinkItem = "header-module--external-link-item--GDRw7";